import {
    Switch,
    Route,
    useHistory,
    useRouteMatch,
  } from "react-router-dom";
import Artist from "./Artist";
import { firestore } from "./firebase";
import Sidebar from "./Sidebar";
import Fusion from "./Fusion";

export default function Artists() {
    const history = useHistory();

    const newArtist = async () => {
        const reference = firestore.collection('artists').doc();
        history.push(`/artist/${reference.id}`);
    };

    let match = useRouteMatch();
    
    return <div className="h-full flex w-auto">
        <Sidebar newItem={newArtist} newItemText="Neuer Artist" collection="artists" showSearch={true} itemTitle={(item) => item.name} itemLink={(item) => `/artists/${item.objectID}`} />
        <div className="flex-grow overflow-auto">
            <Switch>
                <Route path={`${match.path}/:id1/fusion/:id2`}><Fusion collection="artists" recordType="artist" /></Route>
                <Route path={`${match.path}/:id1/fusion`}><Fusion collection="artists" recordType="artist" /></Route>
                <Route path={`${match.path}/:id`} component={Artist}/>
                <Route path={match.path}>
                    <p className="p-3">
                        Bitte selektiere einen Artist.
                    </p>
                </Route>
            </Switch>
        </div>
    </div>;
}